import { Route, Routes } from "react-router"
import "./App.css"
import LoginPage from "@containers/LoginPage/LoginPage"
import ManageAppointmentPage from "@containers/ManageAppointmentPage/ManageAppointmentPage"
import OtherAppsPage from "@containers/OtherAppsPage/OtherAppsPage"
import ManagePatientVisionPage from "@containers/ManagePatientVisionPage/ManagePatientVisionPage"
import NavigationsPage from "@containers/NavigationsPage/NavigationPage"
import DashBoardPage from "@containers/DashBoardPage/DashBoardPage"
import ContactPage from "@containers/ContactPage/ContactPage"
import ReportPage from "./containers/ReportPage/ReportPage"
import SignUpPage from "@containers/SignUpPage/SignUpPage"
import ForgotPasswordPage from "@containers/ForgotPassword/ForgotPasswordPage"
import ViewPatientPage from "@containers/ViewPatientPage/ViewPatientPage"
import MyAccountPage from "@containers/MyAccountPage/MyAccountPage"
import AddNewPatientPage from "@containers/AddNewPatient/AddNewPatientPage"
import AddRegisteredPatientPage from "@containers/AddRegisteredPatientPage/AddRegisteredPatientPage"
import CheckoutPage from "@containers/CheckoutPage/CheckoutPage"
import SubscriptionPage from "@containers/SubscriptionPage/SubscriptionPage"
import ScheduleAppointmentPage from "@containers/ScheduleAppointmentPage/ScheduleAppointmentPage"
import { Navigate } from "react-router"
import ProtectedRoute from "@components/ProtectedRoute/ProtectedRoute"
import PublicRoute from "@components/PublicRoute/PublicRoute"
import useProfile from "@hooks/useProfile"
import { useEffect } from "react"
import { useSelector } from "react-redux"
import OAuthRedirect from "@components/OAuthRedirect"
import PageNotFoundPage from "@containers/PageNotFoundPage/PageNotFoundPage"
import PrivacyPolicy from "@components/PrivacyPolicy/PrivacyPolicy"
import AppointmentDetails from "@components/Appointments/AppointmentDetails"
import AppointmentDetailsPage from "@containers/AppointmentDetailsPage/AppointmentDetailsPage"


function App() {
  const { handleGetOwnDetails } = useProfile()
  const { ownDetails } = useSelector((state) => state.profile)

  useEffect(() => {
    if (!ownDetails) {
      handleGetOwnDetails()
    }
  }, [ownDetails, handleGetOwnDetails])

  return (
    <>
      <Routes>
        <Route path="*" element={<PageNotFoundPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Navigate to="/dashboard" />
            </ProtectedRoute>
          }
        />
        <Route path="/sign-in" element={
          <PublicRoute>          
            <LoginPage />
          </PublicRoute>
          } 
        />
        <Route path="/sign-up" element={
          <PublicRoute> 
            <SignUpPage />
          </PublicRoute> 
          } 
        />
        <Route path="/forgot-password" element={
          <PublicRoute> 
            <ForgotPasswordPage />
          </PublicRoute> 
          } 
        />
        <Route
          path="/oauth-redirect"
          element={
            <ProtectedRoute>
              <OAuthRedirect />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-appointment"
          element={
            <ProtectedRoute>
              <ManageAppointmentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-appointment/schedule-appointment"
          element={
            <ProtectedRoute>
              <ScheduleAppointmentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-appointment/appointment-details"
          element={
            <ProtectedRoute>
              <AppointmentDetailsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/other-apps"
          element={
            <ProtectedRoute>
              <OtherAppsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-patient-vision"
          element={
            <ProtectedRoute>
              <ManagePatientVisionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-patient-vision/add-new-patient"
          element={
            <ProtectedRoute>
              <AddNewPatientPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-patient-vision/add-registered-patient"
          element={
            <ProtectedRoute>
              <AddRegisteredPatientPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-patient-vision/view-patient"
          element={
            <ProtectedRoute>
              <ViewPatientPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashBoardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/my-account"
          element={
            <ProtectedRoute>
              <MyAccountPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/navigations"
          element={
            <ProtectedRoute>
              <NavigationsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/contact"
          element={
            <ProtectedRoute>
              <ContactPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report"
          element={
            <ProtectedRoute>
              <ReportPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscribe"
          element={
            <ProtectedRoute>
              <SubscriptionPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/subscribe/checkout"
          element={
            <ProtectedRoute>
              <CheckoutPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <PrivacyPolicy />
          }
        />
      </Routes>
    </>
  )
}

export default App
